// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2a1v8","signatureButtonsRight":"ModalSign_signatureButtonsRight__3IccI"};